import { Component } from 'react'
import { ContactPoints, Communications, CodeableConcepts, Contacts, Addresses } from '../helpers'
import { FaHospitalUser } from 'react-icons/fa6'
import { FaRegAddressCard, FaLanguage } from 'react-icons/fa'
import { BsFillTelephoneFill } from 'react-icons/bs'
import moment from 'moment'
import './resource.css'

class Organization extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Allergy${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>Status</div>
                            <div className='Res-Title'>{this.props.resource.active ? 'Active' : 'Inactive'}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaHospitalUser /></div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.type && 'Type'}</div>
                            <div className='Res-Title'>{this.props.resource.type && CodeableConcepts(this.props.resource.type)}</div>
                        </div>
                    </div>
                    <div className='Res-Row Res-Title'>{this.props.resource.name || 'Organization'}</div>
                    {this.props.resource.alias && this.props.resource.alias.map((a, aidx) => {
                        return <div key={`alias-${aidx}`} className='Res-Row Res-Title'>{a}</div>
                    })}
                    <div className='Res-Row Res-Flex-Spread'>
                        <div>
                            {this.props.resource.telecom && <div className='Res-Row'>
                                <span className={`Res-Icon`}><BsFillTelephoneFill /></span>
                                <div className='Res-Detail'>{ContactPoints(this.props.resource.telecom)}</div>
                            </div>}
                        </div>
                        {this.props.resource.birthDate && <div>
                            <div className='Res-Title'>DOB</div>
                            <div className='Res-Detail'>{moment(this.props.resource.birthDate).format('ll')}</div>
                        </div>}
                    </div>
                    {this.props.resource.communication && <div className='Res-Row'>
                        <span className={`Res-Icon`}><FaLanguage /></span>
                        <div className='Res-Detail'>{Communications(this.props.resource.communication)}</div>
                    </div>}
                    {this.props.resource.contact && <div className='Res-Row'>
                        <span className={`Res-Icon`}><FaRegAddressCard /></span>
                        <div className='Res-Detail'>{Contacts(this.props.resource.contact)}</div>
                    </div>}
                    {this.props.resource.address && <div className='Res-Row Res-Flex'>
                        <div className='Res-Icon'><FaRegAddressCard /></div>
                        <div className='Res-Detail'>{Addresses(this.props.resource.address)}</div>
                    </div>}
                </div>
            }
        </div></div>
    }
}

export default Organization